import { convertGenericConfigToGridConfig as baseConvert } from '../../../../edr/incidentsGrid/types';
import {
  Categories,
  SmartViewsCreateRequest,
  SmartViewsUpdateRequest,
  SmartViewType,
} from '../../../../grid/genericGridSmartViews/types';
import { NetworkViewGridConfig } from './types';

export class SmartViewsHelper {
  public static convertGenericConfigToGridConfig(viewConfig): NetworkViewGridConfig {
    const baseViewConfig = baseConvert(viewConfig);

    return {
      ...baseViewConfig,
      recursive: !!viewConfig.specifics.recursive,
      treeDetails: viewConfig.specifics.treeDetails,
    };
  }

  public static convertGridConfigToGenericConfig(viewConfig): SmartViewsCreateRequest {
    const specifics = viewConfig.details.specifics;
    return {
      category: Categories.SAVED,
      type: SmartViewType.NETWORK_V2,
      specifics: {
        filters: specifics.filters,
        displayedColumns: specifics.displayedColumns,
        compactView: specifics.compactView,
        pageSize: specifics.pageSize,
        columnConfigs: specifics.columnConfigs,
        recursive: specifics.recursive,
        treeDetails: specifics.treeDetails,
      },
    };
  }

  public static processSmartViewForUpdate(viewConfig): SmartViewsUpdateRequest {
    return {
      id: viewConfig.id,
      details: {
        specifics: {
          filters: viewConfig.filters,
          displayedColumns: viewConfig.displayedColumns,
          compactView: viewConfig.compactView,
          pageSize: viewConfig.pageSize,
          columnConfigs: viewConfig.columnConfigs,
          recursive: viewConfig.recursive,
          treeDetails: viewConfig.treeDetails,
        },
      },
    };
  }
}
